<!--
Date: 2025-08-20
Desc: 找回密码组件
 -->
<template>
    <div>
        <div class="comp-reset-num comp">
            <div class="reset-num-box">
                <step :navs="navs" />
                <div v-if="showMobileVerifyTitle" class="send-mobile-text">验证手机号码</div>
                <div class="check-acct">
                    <el-form
                        v-if="showIdentityForm"
                        ref="pwdForm"
                        :model="pwdForm"
                        :rules="rules"
                        label-width="446px"
                        inline-message
                        class="user-info-checked"
                        v-on:submit.native.prevent
                    >
                        <el-form-item
                            v-if="showOrgProductAccountTypeSelect"
                            label="客户类型:"
                            prop="accountType"
                        >
                            <el-select
                                v-model="pwdForm.accountType"
                                placeholder="请选择客户类型"
                                v-on:change="handleAccountTypeChange"
                            >
                                <el-option
                                    v-for="item in orgProductAccountTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="证件类型:" prop="certType">
                            <el-select
                                v-model="pwdForm.certType"
                                placeholder="请选择证件类型"
                                v-on:change="checkCertNoAgain"
                            >
                                <el-option
                                    v-for="item in certTypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="证件号码:" prop="certNo">
                            <el-input
                                v-model.trim="pwdForm.certNo"
                                placeholder="请输入证件号码"
                                :maxlength="20"
                            />
                        </el-form-item>
                        <el-form-item :label="identityNameLabel" prop="userName">
                            <el-input
                                v-model.trim="pwdForm.userName"
                                :placeholder="identityNamePlaceholder"
                                :maxlength="20"
                            />
                        </el-form-item>
                        <div class="btn-contain">
                            <button class="cancel-btn" v-on:click="returnBack">取消</button>
                            <button class="next-btn" v-on:click="submitInfo('pwdForm')">
                                下一步
                            </button>
                        </div>
                    </el-form>
                    <el-form
                        v-if="showVerifyForm"
                        ref="pwdForm"
                        :model="pwdForm"
                        :rules="rules"
                        label-width="446px"
                        inline-message
                        v-on:submit.native.prevent
                    >
                        <el-form-item
                            v-if="showBankIdentityFields"
                            label="证件类型:"
                            prop="certType"
                        >
                            <el-select
                                v-model="pwdForm.certType"
                                placeholder="请选择证件类型"
                                :disabled="way === 'trade'"
                                v-on:change="checkCertNoAgain"
                            >
                                <el-option
                                    v-for="item in certTypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="showBankIdentityFields" label="证件号码:" prop="certNo">
                            <span v-if="way === 'trade'">{{ pwdForm.certNo }}</span>
                            <el-input
                                v-else
                                v-model.trim="pwdForm.certNo"
                                placeholder="请输入证件号码"
                                :maxlength="20"
                            />
                        </el-form-item>
                        <el-form-item
                            v-if="showBankIdentityFields"
                            :label="identityNameLabel"
                            prop="userName"
                        >
                            <span v-if="way === 'trade'">{{ pwdForm.userName }}</span>
                            <el-input
                                v-else
                                v-model.trim="pwdForm.userName"
                                :placeholder="identityNamePlaceholder"
                                :maxlength="20"
                                :disabled="way === 'trade'"
                            />
                        </el-form-item>
                        <el-form-item
                            v-if="showBankFields"
                            label="选择银行卡:"
                            prop="bankType"
                            class="bank"
                        >
                            <div
                                class="bank-msg"
                                :style="{ opacity: bankInfo.channelid ? 1 : 0 }"
                                v-on:click.prevent="showBank"
                            >
                                <div
                                    v-if="bankInfo.channelid"
                                    class="bank-img-sel clear"
                                    :class="{ 'bg-w': bankInfo.channelid }"
                                >
                                    <img :src="$util.getImg(bankInfo.bankcode)" alt="" />
                                    <span class="k-text-flow" :title="bankInfo.bankname">
                                        {{ bankInfo.bankname.toString().substr(0, 6) }}
                                    </span>
                                    <i
                                        aria-hidden="true"
                                        class="paycenter"
                                        :title="bankInfo.paycentername"
                                    >
                                        {{ bankInfo.paycentername.toString().substr(0, 4) }}
                                    </i>
                                </div>
                            </div>
                            <el-input
                                v-model.trim="pwdForm.bankType"
                                placeholder="请选择银行卡"
                                :maxlength="20"
                                suffix-icon="fa fa-money-check"
                            />
                        </el-form-item>
                        <el-form-item v-if="showBankFields" label="银行卡号码:" prop="bankNo">
                            <div
                                class="bank-code el-message--warning"
                                :class="{ show: showBankCard && pwdForm.bankNo !== '' }"
                            >
                                {{ $util.getNewCard(pwdForm.bankNo) }}
                            </div>
                            <el-input
                                v-model.trim="pwdForm.bankNo"
                                placeholder="请输入完整银行卡号码"
                                :maxlength="20"
                                v-on:focus="showBankCard = true"
                                v-on:blur="showBankCard = false"
                            />
                        </el-form-item>
                        <el-form-item
                            v-if="showTradeInfoFields"
                            label="销售机构:"
                            prop="distributorcode"
                        >
                            <el-select
                                v-model="pwdForm.distributorcode"
                                filterable
                                remote
                                clearable
                                reserve-keyword
                                placeholder="请选择销售机构"
                                :remote-method="queryDistributorList"
                                :loading="distributorLoading"
                                v-on:clear="handleDistributorClear"
                            >
                                <el-option
                                    v-for="item in distributorList"
                                    :key="item.distributorcode"
                                    :label="item.distributorname"
                                    :value="item.distributorcode"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if="showTradeInfoFields"
                            label="曾购买产品:"
                            prop="fundcode"
                        >
                            <el-select
                                v-model="pwdForm.fundcode"
                                filterable
                                remote
                                clearable
                                reserve-keyword
                                placeholder="请选择曾购买产品"
                                :remote-method="queryFundList"
                                :loading="fundLoading"
                                v-on:clear="handleFundClear"
                            >
                                <el-option
                                    v-for="item in fundList"
                                    :key="item.fundcode"
                                    :label="formatFundOption(item)"
                                    :value="item.fundcode"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if="showMobileFields"
                            :label="showBankFields ? '预留手机号' : '手机号码'"
                            prop="mobileno"
                        >
                            <el-input
                                v-model.trim="pwdForm.mobileno"
                                :placeholder="plaC"
                                :maxlength="11"
                            />
                        </el-form-item>
                        <el-form-item v-if="showSmsCodeField" label="短信验证码:" prop="verifyCode">
                            <el-input
                                v-model.trim="pwdForm.verifyCode"
                                placeholder="请输入验证码"
                                :maxlength="6"
                            >
                                <span
                                    slot="suffix"
                                    :disabled="time > 0"
                                    :class="time > 0 ? 'get-verify-disabled' : 'get-verify'"
                                    v-on:click="mobileCode"
                                >
                                    {{ btnMsg }}
                                </span>
                            </el-input>
                        </el-form-item>
                        <div class="btn-contain">
                            <button class="cancel-btn" v-on:click="returnBack">取消</button>
                            <button class="next-btn" v-on:click="mobileCheck">下一步</button>
                        </div>
                    </el-form>
                </div>
                <bank-lists
                    v-if="showBankFields && bankCardsLoaded"
                    ref="bankList"
                    :bank-visible="bankVisible"
                    :bank-auth="true"
                    :required-bank-card-list="requiredBankCardList"
                    v-on:bank-hide="getBankMsg"
                />
                <set-pwd
                    v-if="pwdShow"
                    :pwd-con="pwdSet"
                    :proto="true"
                    class="set-pwd-comp"
                    v-on:pwd-get="pwdOk"
                />
                <img-code
                    :dialog-visible="dialogVisible"
                    :biztype="biztype"
                    v-on:verify-in="getVerifyCode"
                />
                <result
                    v-if="pwdResult"
                    :result="result"
                    v-on:login-now="findPwd"
                    v-on:return-login="backLogin"
                    v-on:return-back="returnBack"
                    v-on:return-home="backHome"
                />
            </div>
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import bankLists from "@/components/form/bankListsDc.vue";
import step from "@/components/layout/step.vue";
import setPwd from "@/components/layout/setPwdDc.vue";
import imgCode from "@/components/layout/imgCode.vue";
import result from "@/components/layout/resultDc.vue";
import userApi from "@/api/user";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";

export default {
    name: "RetrievePwdNew",
    components: {
        bankLists,
        setPwd,
        imgCode,
        result,
        step,
        footerQuestions
    },
    props: {
        way: {
            type: String,
            default: ""
        },
        pwdrecoverytype: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            time: 0,
            mobileno: "",
            pwdForm: {
                accountType: "",
                userName: "",
                certType: "00",
                certNo: "",
                bankType: "",
                bankNo: "",
                mobileno: "",
                verifyCode: "",
                distributorcode: "",
                fundcode: "",
                en_certificateno: "",
                en_custname: ""
            },
            acctInfo: {
                name: "",
                certNo: ""
            },
            showBankCard: false,
            pwdSet: {},
            result: {
                cla: "register-success",
                msg: "您好，登录密码已重置成功！",
                btnMsg: "该密码用于登录系统",
                btnL: {},
                btnR: {
                    text: "确定",
                    event: "return-login"
                }
            },
            randomToken: "",
            pwdShow: false,
            pwdResult: false,
            bankVisible: false,
            dialogVisible: false,
            navs: [],
            certTypes: [],
            btnMsg: "获取验证码",
            plaC: "请输入手机号码",
            checkBank: false,
            locked: false,
            bankInfo: {},
            biztype: "",
            currentRecoveryType: 0,
            currentStage: "identity",
            rules: {
                accountType: [
                    {
                        required: true,
                        message: "请选择客户类型",
                        trigger: "change"
                    }
                ],
                userName: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error(this.identityNamePlaceholder));
                                return;
                            }
                            callback();
                        },
                        trigger: "change"
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (this.way === "trade" || this.isOrgProductRecovery) {
                                callback();
                                return;
                            }
                            this.$util.validateName(rule, value, callback, this.pwdForm.certType);
                        },
                        trigger: "blur"
                    }
                ],
                certType: [
                    {
                        required: true,
                        message: "请选择证件类型",
                        trigger: "change"
                    }
                ],
                certNo: [
                    {
                        required: true,
                        message: "请输入证件号码",
                        trigger: "change"
                    },
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                bankType: [
                    {
                        required: true,
                        message: "请选择所属银行",
                        trigger: "blur"
                    }
                ],
                bankNo: [
                    {
                        required: true,
                        message: "请输入银行卡号码",
                        trigger: "change"
                    },
                    { validator: this.$util.validateBankNum, trigger: "blur" }
                ],
                mobileno: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                verifyCode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "blur"
                    },
                    {
                        validator: this.$util.validateVerifyCode,
                        trigger: "blur"
                    }
                ],
                distributorcode: [
                    {
                        required: true,
                        message: "请选择销售机构",
                        trigger: "change"
                    }
                ],
                fundcode: [
                    {
                        required: true,
                        message: "请选择曾购买产品",
                        trigger: "change"
                    }
                ]
            },
            warningHtml: "",
            commonQuestion: [],
            requiredBankCardList: [],
            bankCardsLoaded: false,
            distributorList: [],
            fundList: [],
            distributorLoading: false,
            fundLoading: false,
            orgProductAccountTypes: [
                { value: "institution", label: "机构户", invtp: "0" },
                { value: "product", label: "产品户", invtp: "2" }
            ]
        };
    },
    computed: {
        passwordType() {
            return String(this.$cache.getCompanyInfoParam("10109008") || "");
        },
        routeAccountType() {
            return String(this.$route.query.accounttype || "personal");
        },
        routeInvtp() {
            return String(
                this.$route.query.invtp || (this.routeAccountType === "personal" ? "1" : "")
            );
        },
        isConsignmentPasswordEntry() {
            return String(this.$route.query.fromConsignmentPwd || "") === "1";
        },
        showOrgProductAccountTypeSelect() {
            // 仅从代销获取登录密码入口进来时允许切换机构/产品户，避免影响普通忘记密码。
            return (
                this.isConsignmentPasswordEntry &&
                Number(this.currentRecoveryType) === 1 &&
                ["institution", "product"].includes(this.routeAccountType)
            );
        },
        accountType() {
            if (this.showOrgProductAccountTypeSelect) {
                return String(this.pwdForm.accountType || this.routeAccountType);
            }
            return this.routeAccountType;
        },
        invtp() {
            if (this.showOrgProductAccountTypeSelect) {
                return this.getInvtpByAccountType(this.accountType);
            }
            return this.routeInvtp;
        },
        isOrgProductRecovery() {
            return (
                ["institution", "product"].includes(this.accountType) ||
                ["0", "2"].includes(this.invtp)
            );
        },
        identityStepLabel() {
            return this.isOrgProductRecovery ? "身份校验" : "身份证校验";
        },
        orgProductNameText() {
            // 机构/产品户找回密码的名称项必须跟随客户类型，避免统一文案误导录入。
            if (this.accountType === "product" || this.invtp === "2") {
                return "产品名称";
            }
            return "机构名称";
        },
        identityNameLabel() {
            return this.isOrgProductRecovery ? `${this.orgProductNameText}:` : "真实姓名:";
        },
        identityNamePlaceholder() {
            return this.isOrgProductRecovery
                ? `请输入${this.orgProductNameText}`
                : "请输入真实姓名";
        },
        isConsignmentTradeInfoMode() {
            return (
                Number(this.currentRecoveryType) === 1 &&
                String(this.$cache.getCompanyInfoParam("10114012") || "0") === "1"
            );
        },
        flowMode() {
            const recoveryType = Number(this.currentRecoveryType);
            if (recoveryType === 1) {
                if (this.isConsignmentTradeInfoMode) {
                    return "identity_trade";
                }
                return "identity_mobile";
            }
            if (recoveryType === 2) {
                return "mobile_only";
            }
            if (this.passwordType === "1") {
                return "identity_mobile";
            }
            return "identity_bank";
        },
        isIdentityBankFlow() {
            return Number(this.currentRecoveryType) === 0 && this.passwordType !== "1";
        },
        showIdentityForm() {
            return this.currentStage === "identity";
        },
        showVerifyForm() {
            return this.currentStage === "verify";
        },
        showBankFields() {
            return this.showVerifyForm && this.checkBank;
        },
        showTradeInfoFields() {
            return this.showVerifyForm && this.flowMode === "identity_trade";
        },
        showMobileFields() {
            return this.showVerifyForm && !this.showTradeInfoFields;
        },
        showBankIdentityFields() {
            return this.showBankFields && !this.isIdentityBankFlow;
        },
        showSmsCodeField() {
            return (
                this.showVerifyForm &&
                !this.showTradeInfoFields &&
                (!this.checkBank ||
                    this.bankInfo.bankauthtype == "1" ||
                    (this.bankInfo.bankauthtype == "0" && this.bankInfo.identifytype == "1"))
            );
        },
        showMobileVerifyTitle() {
            return this.showVerifyForm && !this.checkBank && !this.showTradeInfoFields;
        }
    },
    watch: {
        pwdrecoverytype(newType, oldType) {
            if (newType === oldType) {
                return;
            }
            this.setupFlow(newType, true);
        }
    },
    created() {
        this.warningHtml = warningHtml.warningHtml1;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion1;
        this.certTypes = this.getCertTypes();
        this.setupFlow(this.pwdrecoverytype, true);
    },
    methods: {
        getInvtpByAccountType(accountType) {
            const matchedAccountType = this.orgProductAccountTypes.find(
                (item) => item.value === accountType
            );
            if (matchedAccountType) {
                return matchedAccountType.invtp;
            }
            return accountType === "personal" ? "1" : "";
        },
        getCertDictItem(accountType = this.accountType, invtp = this.invtp) {
            if (accountType === "product" || invtp === "2") {
                return "131008";
            }
            if (accountType === "institution" || invtp === "0") {
                return "130008";
            }
            return "130007";
        },
        getCertTypes(accountType = this.accountType, invtp) {
            const certInvtp =
                invtp === undefined ? this.getInvtpByAccountType(accountType) || this.invtp : invtp;
            // 证件字典必须和当前客户类型同步，避免重置表单时读取到旧 pwdForm 推导出的 invtp。
            const dictItem = this.getCertDictItem(accountType, certInvtp);
            return JSON.parse(JSON.stringify(this.$cache.getDict(dictItem) || [])).filter(
                (item) => {
                    return item.subitem !== "000" && item.subitemname !== "基金账号";
                }
            );
        },
        getDefaultAccountType() {
            return this.showOrgProductAccountTypeSelect ? this.routeAccountType : this.accountType;
        },
        getDefaultCertType() {
            return this.certTypes[0] ? this.certTypes[0].subitem : "00";
        },
        getDefaultPwdForm(accountType = this.getDefaultAccountType()) {
            return {
                accountType,
                userName: "",
                certType: this.getDefaultCertType(),
                certNo: "",
                bankType: "",
                bankNo: "",
                mobileno: "",
                verifyCode: "",
                distributorcode: "",
                fundcode: "",
                en_certificateno: "",
                en_custname: ""
            };
        },
        getPwdSetConfig() {
            const isLoginPassword = this.passwordType === "1";
            return {
                text: "登录",
                validateText: "登录",
                pwdLabel: isLoginPassword ? "设置登录密码：" : "设置密码：",
                pwdPlaceholder: isLoginPassword ? "请输入登录密码" : "请输入密码",
                confirmLabel: isLoginPassword ? "确认登录密码：" : "确认密码：",
                confirmPlaceholder: isLoginPassword ? "请再次输入登录密码" : "请再次输入密码"
            };
        },
        applyTradeInfo() {
            if (this.way !== "trade") {
                return;
            }
            const info = this.$cache.getUser();
            this.pwdForm.certType = info.certificatetype;
            this.pwdForm.certNo = info.certificateno;
            this.pwdForm.userName = info.custname;
            this.pwdForm.en_certificateno = info.en_certificateno;
            this.pwdForm.en_custname = info.en_custname;
        },
        getStepLabels() {
            if (this.flowMode === "identity_mobile") {
                return [this.identityStepLabel, "手机号验证", "设置新密码", "完成修改"];
            }
            if (this.flowMode === "identity_trade") {
                return [this.identityStepLabel, "交易信息验证", "设置新密码", "完成修改"];
            }
            if (this.flowMode === "identity_bank") {
                return [this.identityStepLabel, "银行卡验证", "设置新密码", "完成修改"];
            }
            if (this.flowMode === "mobile_only") {
                return ["手机号验证", "设置新密码", "完成修改"];
            }
            return ["银行卡验证", "设置新密码", "完成修改"];
        },
        getActiveCount(stage) {
            if (
                this.flowMode === "identity_mobile" ||
                this.flowMode === "identity_trade" ||
                this.flowMode === "identity_bank"
            ) {
                return {
                    identity: 1,
                    verify: 2,
                    password: 3,
                    done: 4
                }[stage];
            }
            return {
                identity: 1,
                verify: 1,
                password: 2,
                done: 3
            }[stage];
        },
        updateNavs(stage = this.currentStage) {
            const activeCount = this.getActiveCount(stage) || 1;
            this.navs = this.getStepLabels().map((val, index) => ({
                val,
                active: index < activeCount
            }));
        },
        resetLocalForm() {
            const accountType = this.getDefaultAccountType();
            this.certTypes = this.getCertTypes(
                accountType,
                this.getInvtpByAccountType(accountType)
            );
            this.pwdForm = this.getDefaultPwdForm(accountType);
            this.bankInfo = {};
            this.requiredBankCardList = [];
            this.bankCardsLoaded = false;
            this.distributorList = [];
            this.fundList = [];
            this.applyTradeInfo();
        },
        handleAccountTypeChange(accountType) {
            this.certTypes = this.getCertTypes(
                accountType,
                this.getInvtpByAccountType(accountType)
            );
            this.pwdForm.certType = this.getDefaultCertType();
            this.pwdForm.certNo = "";
            this.$nextTick(() => {
                if (this.$refs.pwdForm) {
                    this.$refs.pwdForm.clearValidate(["accountType", "certType", "certNo"]);
                }
            });
        },
        async loadRequiredBankCards() {
            this.bankCardsLoaded = false;
            this.requiredBankCardList = [];
            const res = await this.$util.getBusinesBankInfo({
                businessflag: "9",
                findtype: this.biztype
            });
            const bankLists = res.filter(
                (item) => item.authenticateflag === "1" && item.ischannelstop === "1"
            );
            if (bankLists.length > 0) {
                this.requiredBankCardList = bankLists;
            } else {
                this.requiredBankCardList = [{ bankcode: "__NO_MATCH_BANK__" }];
                this.$message.error("您未开户或未绑定支持找回密码的银行卡");
            }
            this.bankCardsLoaded = true;
        },
        getResponseList(res) {
            const data = (res && res.data) || res || {};
            if (Array.isArray(data)) {
                return data;
            }
            if (Array.isArray(data.list)) {
                return data.list;
            }
            if (Array.isArray(data.returnList)) {
                return data.returnList;
            }
            return [];
        },
        async loadTradeInfoOptions() {
            await Promise.all([this.queryDistributorList(""), this.queryFundList("")]);
        },
        async queryDistributorList(keyword = "") {
            this.distributorLoading = true;
            try {
                const res = await userApi.qryCrmDistributor({ keyword });
                this.distributorList = this.getResponseList(res)
                    .map((item) => ({
                        distributorcode: item.distributorcode || item.distributorCode || item.code,
                        distributorname:
                            item.distributorname ||
                            item.distributorName ||
                            item.name ||
                            item.distributorcode ||
                            item.distributorCode ||
                            item.code
                    }))
                    .filter((item) => item.distributorcode);
            } finally {
                this.distributorLoading = false;
            }
        },
        async queryFundList(keyword = "") {
            this.fundLoading = true;
            try {
                const res = await userApi.qryCrmFundInfo({
                    keyword,
                    fundcode: "",
                    pagesize: 10,
                    pagenum: 1
                });
                // 曾购买产品必须按CRM/CC历史产品口径取数，避免CMS在售列表漏掉已下架或清仓产品。
                this.fundList = this.getResponseList(res)
                    .map((item) => ({
                        fundcode: item.fundcode || item.fundCode || item.code,
                        fundname: item.fundname || item.fundName || item.name
                    }))
                    .filter((item) => item.fundcode);
            } finally {
                this.fundLoading = false;
            }
        },
        formatFundOption(item) {
            return item.fundname ? `${item.fundname}(${item.fundcode})` : item.fundcode;
        },
        handleDistributorClear() {
            this.queryDistributorList("");
        },
        handleFundClear() {
            this.queryFundList("");
        },
        setupFlow(type, resetForm = false) {
            const nextType = Number(type);
            this.currentRecoveryType = Number.isNaN(nextType) ? 0 : nextType;
            if (resetForm) {
                this.resetLocalForm();
            }
            this.biztype =
                this.currentRecoveryType === 2
                    ? this.$const.IMG_BIZTYPE.REGISTERPWD
                    : this.currentRecoveryType === 1
                    ? this.$const.IMG_BIZTYPE.CONSIGNMENTPWD
                    : this.$const.IMG_BIZTYPE.RESETLOGINPWD;
            this.pwdSet = this.getPwdSetConfig();
            this.locked = false;
            this.time = 0;
            this.btnMsg = "获取验证码";
            this.bankVisible = false;
            this.dialogVisible = false;
            this.pwdShow = false;
            this.pwdResult = false;
            this.currentStage =
                this.flowMode === "mobile_only" || this.flowMode === "bank_auth"
                    ? "verify"
                    : "identity";
            this.checkBank =
                this.way === "trade" ||
                this.flowMode === "bank_auth" ||
                (this.flowMode === "identity_bank" && this.currentStage === "verify");
            this.plaC = this.checkBank ? "请输入银行预留手机号码" : "请输入手机号码";
            this.updateNavs();
            if (this.checkBank) {
                this.loadRequiredBankCards();
            }
            this.$nextTick(() => {
                if (this.$refs.pwdForm) {
                    this.$refs.pwdForm.clearValidate();
                }
            });
        },
        checkCertNoAgain() {
            if (this.$refs.pwdForm) {
                this.$refs.pwdForm.validateField("certNo");
            }
        },
        findPwd() {
            this.$router.push({
                name: "resetpwdway",
                query: { tit: "找回密码" }
            });
        },
        showPwd(flag) {
            this.currentStage = "password";
            this.pwdShow = true;
            this.updateNavs("password");
            if (flag) {
                this.infoChecked = "1";
            }
        },
        handleIdentitySuccess(needidentify) {
            if (needidentify && this.currentRecoveryType === 1) {
                this.currentRecoveryType = 0;
                this.biztype = this.$const.IMG_BIZTYPE.RESETLOGINPWD;
            }
            if (this.isIdentityBankFlow) {
                this.checkBank = true;
                this.plaC = "请输入银行预留手机号码";
                this.currentStage = "verify";
                this.updateNavs("verify");
                this.loadRequiredBankCards();
                return;
            }
            if (this.flowMode === "identity_trade") {
                this.checkBank = false;
                this.currentStage = "verify";
                this.updateNavs("verify");
                this.loadTradeInfoOptions().finally(() => {
                    this.clearTradeInfoValidate();
                });
                // 交易信息表单刚展示时不应立即暴露必填错误，保留到用户点击下一步再校验。
                this.clearTradeInfoValidate();
                return;
            }
            if (this.flowMode === "identity_mobile") {
                this.checkBank = false;
                this.plaC = "请输入手机号码";
                this.currentStage = "verify";
                this.updateNavs("verify");
                return;
            }
            this.checkBank = true;
            this.plaC = "请输入银行预留手机号码";
            this.currentStage = "verify";
            this.updateNavs("verify");
            this.loadRequiredBankCards();
        },
        submitInfo(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const params = {
                        custname: this.pwdForm.userName,
                        certificatetype: this.pwdForm.certType,
                        certificateno: this.pwdForm.certNo,
                        biztype: this.biztype
                    };
                    if (this.isOrgProductRecovery) {
                        params.invtp = this.invtp;
                        params.accounttype = this.accountType;
                    }
                    try {
                        const res = await userApi.identifyVerification(params);
                        if (res.code == "0") {
                            this.handleIdentitySuccess(Boolean(res.data && res.data.needidentify));
                        }
                    } catch (e) {
                        // 0130301 在全局拦截器中不弹提示，这里仅保留直销账户拦截提示。
                        if (e && e.code === "0130301") {
                            this.$message.error(
                                e.msg || "您已开立直销账户，请通过【忘记密码】找回登录密码。"
                            );
                        }
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        validateFormFields(fields) {
            let message = "";
            fields.forEach((field) => {
                this.$refs.pwdForm.validateField(field, (str) => {
                    if (str && !message) {
                        message = str;
                    }
                });
            });
            return message;
        },
        clearTradeInfoValidate() {
            this.$nextTick(() => {
                if (this.$refs.pwdForm) {
                    this.$refs.pwdForm.clearValidate(["distributorcode", "fundcode"]);
                }
            });
        },
        mobileCode() {
            const fields = this.showBankFields
                ? [
                      ...(this.showBankIdentityFields ? ["certType", "certNo", "userName"] : []),
                      "bankType",
                      "bankNo",
                      "mobileno"
                  ]
                : ["mobileno"];
            const message = this.validateFormFields(fields);
            if (message) {
                return false;
            }
            this.$util.validateMobile(
                { regular: /^1[3-9]\d{9}$/ },
                this.pwdForm.mobileno,
                async (err) => {
                    if (!err) {
                        if (this.$cache.getSysParam("10103010") == "2" || this.checkBank) {
                            this.getVerifyCode("1");
                        } else {
                            this.dialogVisible = true;
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: err.message
                        });
                    }
                }
            );
            return false;
        },
        async checkVerifyCode(val) {
            let res = {};
            if (this.checkBank) {
                res = await userApi.restPwdAuthReceive({
                    smscode: val,
                    biztype: this.biztype,
                    mobileno: this.mobileno
                });
            } else {
                res = await userApi.checkSmsCode({
                    smscode: val,
                    biztype: this.biztype
                });
            }
            return res.code === "0";
        },
        needResetLoginPwdVerifyOnMobile() {
            return Number(this.currentRecoveryType) === 0 && this.passwordType === "1";
        },
        async verifyResetLoginPwdOnMobile() {
            const params = {
                mobileno: this.mobileno || this.pwdForm.mobileno,
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName
            };
            if (this.way === "trade") {
                params.en_certificateno = this.pwdForm.en_certificateno;
                delete params.certificateno;
                params.en_depositname = this.pwdForm.en_custname;
                params.custname = this.pwdForm.en_custname;
            }
            const res = await userApi.resetLoginPwdVerify(params, this.way === "trade");
            return res.code === "0";
        },
        async tradeInfoCheck() {
            const message = this.validateFormFields(["distributorcode", "fundcode"]);
            if (message) {
                return false;
            }
            const params = {
                biztype: this.$const.IMG_BIZTYPE.CONSIGNMENTPWD,
                distributorcode: this.pwdForm.distributorcode,
                fundcode: this.pwdForm.fundcode,
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName
            };
            if (this.isOrgProductRecovery) {
                params.invtp = this.invtp;
                params.accounttype = this.accountType;
            }
            const res = await userApi.resetPwdTradeInfoVerify(params);
            if (res.code === "0") {
                this.showPwd();
                return true;
            }
            this.$message.error("暂无匹配的交易信息，请重试。");
            return false;
        },
        async pwdOk(action, val) {
            if (!action) {
                this.setupFlow(this.currentRecoveryType, true);
                this.$util.btnDisabled(this);
                return;
            }
            const encPwd = this.$util.enc(val.pwd);
            const params = {
                newpwd: encPwd,
                mobileno: this.mobileno
            };
            if (this.isConsignmentTradeInfoMode) {
                params.distributorcode = this.pwdForm.distributorcode;
                params.fundcode = this.pwdForm.fundcode;
            }
            if (this.isOrgProductRecovery) {
                params.invtp = this.invtp;
                params.accounttype = this.accountType;
                params.certificatetype = this.pwdForm.certType;
                params.certificateno = this.pwdForm.certNo;
                params.custname = this.pwdForm.userName;
            }
            let res = {};
            if (this.checkBank) {
                res = await userApi.resetLoginPwd({
                    newpwd: encPwd,
                    opertype: "1"
                });
            } else if (this.currentRecoveryType === 2) {
                res = await userApi.resetPwdRegister(params);
            } else if (this.currentRecoveryType === 1) {
                res = await userApi.resetPwdSearch(params);
            } else {
                res = await userApi.resetLoginPwd(params);
            }
            if (res.data) {
                this.pwdShow = false;
                this.pwdResult = true;
                this.currentStage = "done";
                this.updateNavs("done");
            } else {
                this.result = {
                    cla: "register-fail",
                    msg: "很抱歉，密码重置失败！",
                    btnMsg: "你的账户信息已超时，请你重新找回密码",
                    btnL: {
                        text: "返回登录",
                        event: "return-login"
                    },
                    btnR: {
                        text: "找回密码",
                        event: "login-now"
                    }
                };
            }
        },
        checkCertNo(rule, value, callback) {
            if (this.way === "trade") {
                callback();
                return;
            }
            if (this.isOrgProductRecovery) {
                if (value === "") {
                    callback(new Error("请输入证件号码"));
                    return;
                }
                callback();
                return;
            }
            this.$util.validateCertNo(rule, value, callback, this.pwdForm.certType);
        },
        async mobileCheck() {
            if (this.showTradeInfoFields) {
                await this.tradeInfoCheck();
                return false;
            }
            const fields = this.showBankFields
                ? [
                      ...(this.showBankIdentityFields ? ["certType", "certNo", "userName"] : []),
                      "bankType",
                      "bankNo",
                      "mobileno",
                      ...(this.showSmsCodeField ? ["verifyCode"] : [])
                  ]
                : ["mobileno", "verifyCode"];
            const message = this.validateFormFields(fields);
            if (message) {
                return false;
            }
            if (
                this.showBankFields &&
                this.bankInfo.bankauthtype == "0" &&
                this.bankInfo.identifytype == "0"
            ) {
                this.$message({
                    type: "warning",
                    message: "鉴权或签约方式未配置！"
                });
                return false;
            }
            if (
                this.showBankFields &&
                (this.bankInfo.bankauthtype == "2" ||
                    (this.bankInfo.bankauthtype == "0" && this.bankInfo.identifytype == "2"))
            ) {
                this.sendBank();
                return false;
            }
            if (!this.locked) {
                this.$message({
                    type: "warning",
                    message: "请先发送手机验证码！"
                });
                return false;
            }
            const passed = await this.checkVerifyCode(this.pwdForm.verifyCode);
            if (!passed) {
                return false;
            }
            if (this.needResetLoginPwdVerifyOnMobile()) {
                this.mobileno = this.pwdForm.mobileno;
                const verifyPassed = await this.verifyResetLoginPwdOnMobile();
                if (!verifyPassed) {
                    return false;
                }
            }
            this.showPwd();
            return false;
        },
        async sendBank(val) {
            this.mobileno = this.pwdForm.mobileno;
            let data = {
                mobileno: this.pwdForm.mobileno,
                depositcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.channelname,
                biztype: "01",
                bankcode: this.bankInfo.bankcode
            };
            if (this.showBankIdentityFields || this.isIdentityBankFlow || this.way === "trade") {
                data = {
                    ...data,
                    certificatetype: this.pwdForm.certType,
                    certificateno: this.pwdForm.certNo,
                    custname: this.pwdForm.userName,
                    depositname: this.pwdForm.userName
                };
            }
            if (this.way === "trade") {
                data["en_certificateno"] = this.pwdForm.en_certificateno;
                delete data.certificateno;
                data["en_depositname"] = this.pwdForm.en_custname;
                delete data.depositname;
                data["custname"] = this.pwdForm.en_custname;
            }
            if (
                this.bankInfo.bankauthtype == "1" ||
                (this.bankInfo.bankauthtype == "0" && this.bankInfo.identifytype == "1")
            ) {
                data = {
                    ...data,
                    verifytype: "1",
                    ipsource: "1"
                };
                const res = await userApi.restPwdAuthSend(data, this.way === "trade");
                if (res.code == "0") {
                    this.$message({
                        type: "success",
                        message: "发送手机短信验证码成功"
                    });
                    if (res.data.comtype && res.data.comtype === "socket") {
                        this.showPwd();
                    } else {
                        this.time = res.data.sendperiod;
                        this.locked = true;
                        this.$util.btnDisabled(this);
                    }
                }
                return;
            }
            data.biztype = this.bankInfo.bankauthtype == "2" ? "01" : "02";
            this.randomToken = this.$util.generateRandomNumber();
            let pagecallbackurl =
                window.location.origin + "/sale-mid-ump/bank/redirect?token=" + this.randomToken;
            if (this.bankInfo.paycenterid == "0105") {
                pagecallbackurl = window.location.origin + "/sale-mid-ump/bank/ccb";
            }
            const res = await userApi.restPwdAuthSend(
                {
                    ...data,
                    paychannel: this.bankInfo.paycenterid,
                    pagecallbackurl: pagecallbackurl,
                    signtype: "0",
                    verifytype: "0"
                },
                this.way === "trade"
            );
            if (res.data) {
                const pageUrl = res.data.bankgateurl || "";
                let pageParam = res.data.bankgateparam || {};
                if (pageParam) {
                    pageParam = JSON.parse(pageParam);
                }
                const bankgateserialno = res.data.bankgateserialno;
                const reqMethod = res.data.method;
                this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                const params = {
                    token: this.randomToken,
                    bankcode: this.bankInfo.bankcode,
                    bankcardid: this.acctInfo.bankcardid,
                    mobileno: this.pwdForm.mobileno,
                    paychannel: this.bankInfo.paycenterid,
                    bankgateserialno: bankgateserialno,
                    signtype: "0",
                    isAuthFlag: this.bankInfo.bankauthtype == "2",
                    depositcard: this.pwdForm.bankNo
                };
                if (
                    this.showBankIdentityFields ||
                    this.isIdentityBankFlow ||
                    this.way === "trade"
                ) {
                    params.certificatetype = this.pwdForm.certType;
                    params.certificateno = this.pwdForm.certNo;
                    params.depositname = this.pwdForm.userName;
                }
                if (this.way === "trade") {
                    params["en_certificateno"] = this.pwdForm.en_certificateno;
                    delete params.certificateno;
                    params["en_depositname"] = this.pwdForm.en_custname;
                    delete params.depositname;
                }
                this.$util.confirmBankAuth(this, params, "BankPageAuthentication", () => {
                    this.showPwd();
                });
            }
        },
        showBank() {
            if (!this.showBankFields) {
                return;
            }
            if (!this.bankCardsLoaded) {
                this.$message({
                    type: "warning",
                    message: "银行卡信息加载中，请稍后重试"
                });
                return;
            }
            this.bankVisible = !this.bankVisible;
        },
        getBankMsg(val) {
            this.bankVisible = false;
            if (val && val.bank) {
                this.bankInfo = val.bank;
                this.pwdForm.bankType = this.bankInfo.channelid;
            }
        },
        async getVerifyCode(val) {
            if (this.time > 0) return;
            this.dialogVisible = false;
            if (!val) return;
            if (this.checkBank) {
                this.sendBank(val);
                return;
            }
            this.mobileno = this.pwdForm.mobileno;
            const res = await userApi.sendSms({
                mobileno: this.pwdForm.mobileno,
                biztype: this.biztype,
                verifycode: val
            });
            if (res.code === "0") {
                this.time = res.data.sendperiod;
                this.locked = true;
                this.$util.btnDisabled(this);
            } else {
                this.$message({
                    type: "warning",
                    message: res.msg
                });
            }
        },
        backLogin() {
            this.$router.push("/");
        },
        returnBack() {
            this.setupFlow(this.currentRecoveryType, true);
            this.$util.btnDisabled(this);
            this.$emit("returnBack");
        },
        backHome() {
            this.$router.replace("/home");
        },
        changeCertType() {
            if (!this.$refs.bankList) {
                return;
            }
            if (this.pwdForm.certType === "00") {
                this.$refs.bankList.bankLists = this.$refs.bankList.bankListsAll;
            } else if (this.pwdForm.certType === "0B") {
                this.$refs.bankList.bankLists = this.$refs.bankList.bankLists8;
            }
            this.$refs.bankList.initSelBank();
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-reset-num {
    .bizcomp-reset-lpwd-title {
        height: 60px;
        padding: 17px 20px 22px;
        background: #ffffff;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-text-primary);
        box-sizing: border-box;
        .lpwd-title-tip {
            font-size: 16px;
            font-weight: normal;
            color: var(--color-text-accent);
            margin-left: 8px;
        }
    }
    border: 1px solid var(--color-divided);
    margin-bottom: 20px;
    :deep(.el-form-item__label) {
        font-size: 14px;
        font-weight: normal;
        color: var(--color-text-primary);
    }
    .reset-num-box {
        padding: 38px 0;
    }
    :deep(.step-text) {
        width: 115px !important;
    }
    .send-mobile-text {
        font-size: 24px;
        margin-top: 35px;
        font-weight: normal;
        text-align: center;
        color: var(--color-text-primary);
    }
    .info-box {
        width: 865px;
        height: 40px;
        border-radius: 4px;
        background-color: rgba(224, 234, 255, 0.5);
        box-sizing: border-box;
        border: 1px solid var(--color-divided);
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
        .warn-blue {
            margin: 0 8px 0 20px;
        }
    }
    .el-select {
        width: 400px;
    }
    .el-input {
        font-size: $f16;
        width: 400px;
        .get-verify {
            color: var(--color-primary);
            margin-right: 18px;
            cursor: pointer;
        }
        .get-verify-disabled {
            color: $text-color3;
            cursor: not-allowed;
            margin-right: 18px;
        }
        .fa {
            margin-right: 6px;
        }
    }
    :deep(.el-input__inner) {
        font-size: 16px !important;
        font-weight: normal;
        color: var(--color-text-accent) !important;
    }
    .user-info-checked {
        margin-top: 20px;
    }
    .btn-contain {
        text-align: center;
        .cancel-btn {
            width: 180px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            border-radius: 2px;
            background: var(--color-text-weak);
            cursor: pointer;
            border: none;
            font-size: 16px;
            font-weight: 500;
            color: var(--color-text-regular);
        }
        .next-btn {
            width: 180px;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
            border: none;
            margin-left: 40px;
        }
    }
    .set-pwd-comp {
        padding-top: 20px;
    }
    .bank-msg {
        position: absolute;
        left: 0;
        top: 0;
        border: 1px solid var(--color-divided);
        border-radius: 4px;
        text-indent: 15px;
        -ms-border-radius: 4px;
        background-color: #ffffff;
        width: 400px;
        height: 40px;
        z-index: 10;
        .bank-img-sel {
            text-indent: 0;
            display: inline-block;
            height: 38px;
            margin: 1px 5px;
            padding: 0 10px;
            &.bg-w {
                background: $bg2;
            }
            img {
                margin-top: 3px;
            }
            span {
                color: $text-color2;
                font-size: $f18;
                vertical-align: middle;
                line-height: 30px;
                margin-left: 9px;
                float: left;
                margin-top: 4px;
            }
            img {
                float: left;
            }
            i {
                float: left;
                line-height: 20px;
                margin-left: 10px;
                margin-top: 9px;
            }
        }
    }
}
</style>
